import BaseFileLoadPageMixin from "@/modules/core/file/protected/BaseFileLoadPageMixin";
import Editor from "./MicroCreditFileEditor";
import service from "./MicroCreditFileService";

export default {
  mixins: [BaseFileLoadPageMixin],

  components: {
    Editor
  },

  methods: {
    getService() {
      return service;
    },

    getLabel(instance) {
      return instance.title;
    }
  }
};
